<template>
    <o-flatpickr-wrapper
        class="rounded-0 px-0"
        hide-time
        v-bind="$attrs"
        @input="on_changed"
        @keydown.enter="refilter"
        v-on="inputListeners"
    >
        <template #prepend>
            <BInputGroupPrepend>
                <BButton
                    variant="outline-secondary"
                    small
                    @click="changeExpression"
                    >{{ expr_symbol }}</BButton
                >
            </BInputGroupPrepend>
        </template>
    </o-flatpickr-wrapper>
</template>

<script>
import { BButton, BInputGroupPrepend } from "bootstrap-vue";
import FilterInputMixin from "./FilterInputMixin.js";

export default {
    name: "OFilterDateField",
    components: {
        BInputGroupPrepend,
        BButton,
    },
    mixins: [FilterInputMixin],
    data() {
        return {
            expression: "gt",
            expressions: [
                { code: "eq", text: "=" },
                { code: "gt", text: ">" },
                { code: "lt", text: "<" },
                { code: "ge", text: ">=" },
                { code: "le", text: "<=" },
            ],
        };
    },
    methods: {},
};
</script>
